import { createAction } from '@reduxjs/toolkit';

export const resetSlotsList = createAction<string>('slots/games/resetList');
